import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import { Grid, List, ListItem, ListItemText, Typography } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';

export default function NotiAlertListDocument({
  open,
  document,
  onButtonClick,
  titleDocument,
  downLoadZip,
}) {
  const [listItemDoc, setListItemDoc] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (document) {
      setListItemDoc(document);
    }
  }, [document]);
  return (
    <div>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth="xs"
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '15px',
          },
        }}
      >
        <DialogActions
          sx={{
            backgroundColor: 'primary.main',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50px',
          }}
        >
          <Box
            component="section"
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              textAlign: 'center',
              fontWeight: 'bold',
              color: 'white',
            }}
          >
            {titleDocument}
          </Box>
          <IconButton
            aria-label="close"
            onClick={onButtonClick}
            sx={{ position: 'absolute', right: 0, color: 'white' }}
          >
            <CancelOutlinedIcon />
          </IconButton>
        </DialogActions>

        <DialogContent dividers>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row-reverse',
              bgcolor: 'background.paper',
              borderRadius: 1,
            }}
          >
            <Button
              size="small"
              color="primary"
              sx={{
                color: 'white',
                backgroundColor: 'primary.main',
                width: '180px',
                borderRadius: '20px',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                  boxShadow: 'none',
                },
              }}
              disabled={
                !listItemDoc ||
                listItemDoc.filter((d) => d.document).length === 0
              }
              onClick={() => downLoadZip(`${titleDocument}`, listItemDoc)}
            >
             {t('app.downloadAllDocuments')}
            </Button>
          </Box>
          <Box
            sx={{
              height: '110px',
              marginTop: '10px',
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f1f1f1',
                borderRadius: '4px',
              },
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <List dense={true}>
                  {listItemDoc.map((item, index) => (
                    <ListItem key={index} sx={{ width: '100%' }}>
                      <ListItemText
                        primary={`${index + 1}. ${item.invoice_no}`}
                        sx={{ flexGrow: 1 }}
                      />
                      <Box>
                        {item.document ? (
                          <CheckCircleIcon fontSize="small" color="success" />
                        ) : (
                          <CancelIcon fontSize="small" color="error" />
                        )}
                      </Box>
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => onButtonClick()}
          >
            {t('app.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
